//#region redux
//#endregion
//#region types
import { WintSuperkollAPIModel as ApiModels, WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion

/**
 * @deprecated This service is deprecated. Use useIncomingInvoiceService hook instead.
 *
 * @see useIncomingInvoiceService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const IncomingInvoiceService = {
  getTodoSubType: (
    state: ApiModels.IncomingInvoiceState,
    loggedInUserId: number,
    permissions: { hasInvoicePermissions: boolean; isInvoiceAdmin: boolean; isSignee: boolean },
    receiver?: number
  ): WintSuperkollAPIModel.TodoSubType => {
    if (
      state === ApiModels.IncomingInvoiceState.Received &&
      ((permissions.hasInvoicePermissions && receiver === loggedInUserId) ||
        (permissions.isInvoiceAdmin && receiver === undefined))
    ) {
      return WintSuperkollAPIModel.TodoSubType.IncomingInvoiceToApprove;
    } else if (state === ApiModels.IncomingInvoiceState.Signee && permissions.isSignee) {
      return WintSuperkollAPIModel.TodoSubType.IncomingInvoiceFinalApproval;
    } else {
      return WintSuperkollAPIModel.TodoSubType.IncomingInvoiceMissingApproval;
    }
  },
};

export default IncomingInvoiceService;
